// Default menu settings configurations

export interface MenuDocenteItem {
    title: string;
    icon: string;
    page: string;
    isExternalLink?: boolean;
    issupportExternalLink?: boolean;
    isStarterkitExternalLink?: boolean;
    badge: { type: string, value: string };
    submenu: {
      items: Partial<MenuDocenteItem>[];
    };
    section: string;
  }
  
  export interface MenuConfig {
    vertical_menu: {
      items: Partial<MenuDocenteItem>[]
    };
  }
  
  export const MenuDocenteSettingsConfig: MenuConfig = {
    vertical_menu: {
      items: [
        { section: 'Sé un ofertador', icon: 'la-ellipsis-h' },
        {
          title: 'Nueva oferta',
          icon: 'la-newspaper-o',
          page: '/docente/crearOferta'
        },
        {
          title: 'Mis ofertas publicadas',
          icon: 'la-level-up',
          page: '/docente/ofertasPublicadas'
        },
        {
          title: 'Ofertas en revisión',
          icon: 'la-gavel',
          page: '/docente/enRevision',
        },
        {
          title: 'Historial de ofertas',
          icon: 'la-history',
          page: '/docente/historial',
        },
        { section: 'Control' }
      ]
    }
  
  };
  
  
  
  
  
  